import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import React, { useEffect, useState } from 'react';

import CoachingSpawnLauncher from '../../../../components/coachingSpawnLauncher/CoachingSpawnLauncher';
import { kanbanColorMap } from '../../../../constants';
import { StatusTag } from '../statusTag/StatusTag';
import { exportExcel } from '../toDoView-service';
import CoachingToDoView from '../../../../components/CoachingToDo/CoachingToDoView';

interface ToDoGridProps {
    coachingToDoViewData: any[];
    updateToDoViewData: (props: any, value: any) => void;
    entityId?: string;
}
export type SelectedToDoViewDataType = {
    employeeNumber:string
    title: string;
    description: string;
    startDate: string;
    endDate: string;
}

const statusBodyTemplate = (rowData: any) => {
    return <StatusTag status={rowData.coaching_to_do_status_name} />;
};

export const ToDoGrid = ({ coachingToDoViewData, updateToDoViewData,entityId }: ToDoGridProps) => {
    const [globalFilterValue, setGlobalFilterValue] = useState<any>('');
    const [filters, setFilters] = useState<any>({});
    const [status, setStatus] = useState<any>([]);
    const [entity, setEntity] = useState<any>([]);
    const [statusId, setStatusId] = useState<number | null>(1);
    const [isViewDisplay, setIsViewDisplay] = useState<boolean>(false);
    const [selectedToDoViewData, setSelectedToDoViewData] = useState<SelectedToDoViewDataType|null>(null);

    useEffect(() => {
        const distStatus = Array.from(
            new Set(coachingToDoViewData?.map((item: any) => item.coaching_to_do_status_name))
        );
        setStatus(distStatus);

        const distEntity = Array.from(
            new Set(coachingToDoViewData?.map((item: any) => item.coaching_entity_type_name))
        );
        setEntity(distEntity);
        if(entityId){
            const currentTodo = coachingToDoViewData?.filter(
                (item: any) => item.coaching_to_do_id.toString() === entityId
            );
            if(currentTodo.length>0){
                const event = { field: 'to_do_title', rowData: currentTodo[0] };
                    onToDoClick(event);
            }
        }
    }, [coachingToDoViewData, setStatus, setEntity, entityId]);

    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        // @ts-ignore
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };

    const statusEditor = (props: any) => {
        const statusOptions = Array.from(kanbanColorMap.keys());
        return (
            <Dropdown
                value={props.value}
                options={statusOptions}
                onChange={(e) => props.editorCallback(updateToDoViewData(props, e.value))}
                placeholder="Select a Status"
                className="custom-dropdown"
            />
        );
    };

    const initFilters = () => {
        /* eslint-disable camelcase */
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            start_date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
            recipient: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            to_do_title: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            coaching_to_do_status_name: { value: null, matchMode: FilterMatchMode.IN },
            due_date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
            coaching_entity_type_name: { value: null, matchMode: FilterMatchMode.IN },
        });
        setGlobalFilterValue('');
        /* eslint-enable camelcase */
    };
    const clearFilter = () => {
        initFilters();
    };
    useEffect(() => {
        initFilters();
    }, []);
   
    const statusFilterTemplate = (options: any) => {
        return (
            <MultiSelect
                value={options.value}
                options={status}
                onChange={(e: any) => options.filterApplyCallback(e.value)}
                placeholder="Any"
                className="p-column-filter"
                maxSelectedLabels={1}
            />
        );
    };

    const entityFilterTemplate = (options: any) => {
        return (
            <MultiSelect
                value={options.value}
                options={entity}
                onChange={(e: any) => options.filterApplyCallback(e.value)}
                placeholder="Any"
                className="p-column-filter"
            />
        );
    };
    const renderHeader = () => {
        return (
            <>
                <Divider />
                <div className="d-flex justify-content-between" style={{ textAlign: 'left' }}>
                    <div className="d-flex justify-content-start">
                        <Button type="button" icon="pi pi-filter-slash" className='btn-primary btn-sm' label="Clear" onClick={clearFilter} />
                        <span className="p-input-icon-left ms-3">
                            <i className="pi pi-search" />
                            <InputText
                                value={globalFilterValue}
                                onChange={onGlobalFilterChange}
                                placeholder="Keyword Search"
                            />
                        </span>
                    </div>

                    <div className="d-flex justify-content-end">
                        <CoachingSpawnLauncher statusId={statusId} />
                        <Button
                            type="button"
                            icon="pi pi-upload me-2"
                            className="btn-export mr-2 me-2"
                            onClick={() => {
                                exportExcel(coachingToDoViewData);
                            }}
                            data-pr-tooltip="XLS"
                        >
                            Export All
                        </Button>
                    </div>
                </div>
            </>
        );
    };

    const onToDoClick = (event: any) => {
        if (event.field === 'to_do_title') {
            setIsViewDisplay(true);
            const SeletedRow: SelectedToDoViewDataType = {
                employeeNumber: event?.rowData?.employee_number,               
                title: event?.rowData?.to_do_title,
                description: event?.rowData?.to_do_description,
                startDate: event?.rowData?.start_date,
                endDate: event?.rowData?.due_date
            };           
            setSelectedToDoViewData(SeletedRow);
        }
        if (event.field === 'coaching_todo_status_id') {
            const statusId = event.data.coaching_todo_status_id;
            setStatusId(statusId);
        }
    };

    const header = renderHeader();
    return (
        <>
            <DataTable
                value={coachingToDoViewData}
                header={header}
                dataKey="coaching_to_do_id"
                className="toDoTable"
                scrollable
                scrollHeight="600px"
                globalFilterFields={[
                    'start_date',
                    'recipient',
                    'to_do_title',
                    'coaching_to_do_status_name',
                    'due_date',
                    'coaching_entity_type_name',
                ]}
                filters={filters}
                rows={5}
                rowsPerPageOptions={[5, 10, 25, 50]}
                paginator={coachingToDoViewData?.length > 5}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                onCellClick={onToDoClick}
                cellSelection
                selectionMode="single"
            >
                <Column field="start_date" header="Date" sortable sortField="start_date" dataType="date" />
                <Column
                    field="recipient"
                    header="Recipient"
                    sortable
                    sortField="recipient"
                    filter
                    filterPlaceholder="Search by Recipient"
                />
                <Column
                    field="to_do_title"
                    header="Title"
                    sortable
                    sortField="to_do_title"
                    filter
                    filterPlaceholder="Search by Title"
                    bodyStyle={{ minWidth: '15rem', color: '#007bff', textDecoration: 'underline' }}
                />
                <Column
                    field="coaching_to_do_status_name"
                    header="Status"
                    body={statusBodyTemplate}
                    sortable
                    sortField="coaching_to_do_status_name"
                    filterField="coaching_to_do_status_name"
                    showFilterMatchModes={false}
                    editor={statusEditor}
                    filter
                    filterElement={statusFilterTemplate}
                />
                <Column
                    field="due_date"
                    header="Target Completion Date"
                    sortable
                    sortField="due_date"
                    dataType="date"
                />
                <Column
                    field="coaching_entity_type_name"
                    header="Source"
                    sortable
                    sortField="coaching_entity_type_name"
                    filterField="coaching_entity_type_name"
                    showFilterMatchModes={false}
                    filter
                    filterElement={entityFilterTemplate}
                />
                <Column field="coaching_todo_status_id" header="Status Id" style={{ display: 'none' }} />
            </DataTable>
            {isViewDisplay &&
                <CoachingToDoView
                    visible={isViewDisplay}
                    setVisible={setIsViewDisplay}
                    selectedToDoViewData={selectedToDoViewData}
                />
            }
        </>
    );
};
